/* tslint:disable */
/* eslint-disable */
/**
 * Y-Sports backend-next Management API
 * Composed management-facing contract for `backend-next`. This spec is an aggregation layer over module-scoped contracts and should reference canonical module definitions instead of copying them. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdminPlayerOfficialMatch
 */
export interface AdminPlayerOfficialMatch {
    /**
     * 
     * @type {string}
     * @memberof AdminPlayerOfficialMatch
     */
    matchId: string;
    /**
     * 
     * @type {string}
     * @memberof AdminPlayerOfficialMatch
     */
    tournamentId: string;
    /**
     * 
     * @type {string}
     * @memberof AdminPlayerOfficialMatch
     */
    tournamentName?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof AdminPlayerOfficialMatch
     */
    tournamentDate?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof AdminPlayerOfficialMatch
     */
    categoryId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminPlayerOfficialMatch
     */
    categoryName?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof AdminPlayerOfficialMatch
     */
    matchTime?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof AdminPlayerOfficialMatch
     */
    groupName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminPlayerOfficialMatch
     */
    label?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminPlayerOfficialMatch
     */
    opponentTeamId: string;
    /**
     * 
     * @type {string}
     * @memberof AdminPlayerOfficialMatch
     */
    opponentTeamName?: string | null;
    /**
     * 
     * @type {number}
     * @memberof AdminPlayerOfficialMatch
     */
    teamScore?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AdminPlayerOfficialMatch
     */
    opponentScore?: number | null;
    /**
     * 
     * @type {string}
     * @memberof AdminPlayerOfficialMatch
     */
    status: string;
    /**
     * 
     * @type {string}
     * @memberof AdminPlayerOfficialMatch
     */
    result?: string | null;
}

/**
 * Check if a given object implements the AdminPlayerOfficialMatch interface.
 */
export function instanceOfAdminPlayerOfficialMatch(value: object): value is AdminPlayerOfficialMatch {
    if (!('matchId' in value) || value['matchId'] === undefined) return false;
    if (!('tournamentId' in value) || value['tournamentId'] === undefined) return false;
    if (!('opponentTeamId' in value) || value['opponentTeamId'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function AdminPlayerOfficialMatchFromJSON(json: any): AdminPlayerOfficialMatch {
    return AdminPlayerOfficialMatchFromJSONTyped(json, false);
}

export function AdminPlayerOfficialMatchFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminPlayerOfficialMatch {
    if (json == null) {
        return json;
    }
    return {
        
        'matchId': json['matchId'],
        'tournamentId': json['tournamentId'],
        'tournamentName': json['tournamentName'] == null ? undefined : json['tournamentName'],
        'tournamentDate': json['tournamentDate'] == null ? undefined : (new Date(json['tournamentDate'])),
        'categoryId': json['categoryId'] == null ? undefined : json['categoryId'],
        'categoryName': json['categoryName'] == null ? undefined : json['categoryName'],
        'matchTime': json['matchTime'] == null ? undefined : (new Date(json['matchTime'])),
        'groupName': json['groupName'] == null ? undefined : json['groupName'],
        'label': json['label'] == null ? undefined : json['label'],
        'opponentTeamId': json['opponentTeamId'],
        'opponentTeamName': json['opponentTeamName'] == null ? undefined : json['opponentTeamName'],
        'teamScore': json['teamScore'] == null ? undefined : json['teamScore'],
        'opponentScore': json['opponentScore'] == null ? undefined : json['opponentScore'],
        'status': json['status'],
        'result': json['result'] == null ? undefined : json['result'],
    };
}

export function AdminPlayerOfficialMatchToJSON(json: any): AdminPlayerOfficialMatch {
    return AdminPlayerOfficialMatchToJSONTyped(json, false);
}

export function AdminPlayerOfficialMatchToJSONTyped(value?: AdminPlayerOfficialMatch | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'matchId': value['matchId'],
        'tournamentId': value['tournamentId'],
        'tournamentName': value['tournamentName'],
        'tournamentDate': value['tournamentDate'] == null ? value['tournamentDate'] : value['tournamentDate'].toISOString().substring(0,10),
        'categoryId': value['categoryId'],
        'categoryName': value['categoryName'],
        'matchTime': value['matchTime'] == null ? value['matchTime'] : value['matchTime'].toISOString(),
        'groupName': value['groupName'],
        'label': value['label'],
        'opponentTeamId': value['opponentTeamId'],
        'opponentTeamName': value['opponentTeamName'],
        'teamScore': value['teamScore'],
        'opponentScore': value['opponentScore'],
        'status': value['status'],
        'result': value['result'],
    };
}

